import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-zinc-900 group-[.toaster]:text-zinc-100 group-[.toaster]:border-zinc-700 group-[.toaster]:shadow-[inset_0_1px_0_rgba(229,233,240,.06),0_12px_28px_rgba(0,0,0,.45)] group-[.toaster]:font-body",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "btn-primary group-[.toast]:min-h-[36px] group-[.toast]:px-3 group-[.toast]:text-sm",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
